import { render, staticRenderFns } from "./Pokedex.vue?vue&type=template&id=6a3834fc&scoped=true"
import script from "./Pokedex.vue?vue&type=script&lang=js"
export * from "./Pokedex.vue?vue&type=script&lang=js"
import style0 from "./Pokedex.vue?vue&type=style&index=0&id=6a3834fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3834fc",
  null
  
)

export default component.exports